import { useState } from 'react';
import { parseProblemBody } from '@/api/problem';
import { de } from '@/i18n/de';
import { Button } from '@/shell/ui/button';
import { ConfirmDialog } from '@/shell/ui/dialog';
import { Section } from '@/shell/ui/section';
import { DataGapNotice } from '@/states/data-gap-notice';
import { EmptyState } from '@/states/empty-state';
import { ErrorCard } from '@/states/error-card';
import { LoadingBlock } from '@/states/loading-block';

const SAMPLE_ERROR = parseProblemBody(
  {
    type: 'urn:socialfy:problem:internal',
    title: 'Interner Fehler',
    status: 500,
    code: 'internal',
    requestId: 'beispiel-0001',
  },
  500,
  null,
);

/**
 * Zustandsansicht `/_zustaende`: alle Zustände der Oberfläche auf einer Seite, für Bildschirmfotos und
 * Prüfungen (Kriterium D-6). Nur in Entwicklung und im E2E-Bau erreichbar, nie in Produktion.
 */
export function StatesGallery() {
  const g = de.states.gallery;
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <div className="grid gap-10">
      <h1 className="text-h1 font-bold text-ink">{de.pages.zustaende}</h1>
      <Section title={g.loading}>
        <LoadingBlock height={120} />
      </Section>
      <Section title={g.empty}>
        <EmptyState message={g.emptyMessage} action={{ label: g.emptyAction, href: '/ziele' }} />
      </Section>
      <Section title={g.error}>
        <ErrorCard error={SAMPLE_ERROR} onRetry={() => undefined} />
      </Section>
      <Section title={g.gap}>
        <DataGapNotice since="2026-10-03" />
      </Section>
      <Section title={g.offline} summary={g.offlineHint}>
        <p className="text-body text-ink-muted">{de.states.offlineNoData}</p>
      </Section>
      <Section title={g.dialog}>
        <Button variant="secondary" onClick={() => setDialogOpen(true)}>
          {g.dialogOpen}
        </Button>
        <ConfirmDialog
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          title={g.dialogTitle}
          description={g.dialogText}
          confirmLabel={g.dialogConfirm}
          confirmWord="LÖSCHEN"
          tone="danger"
          onConfirm={() => undefined}
        />
      </Section>
    </div>
  );
}
